import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';
import useMembershipPricing from '@/app/hooks/useMembershipPricing';

import styles from './MembershipBenefits.module.css';

const MembershipBenefits = () => {
  const t = useTranslations();
  const membershipPricingValues = useMembershipPricing({
    footnoteSymbol: '****',
  });

  return (
    <section
      className={cx(styles['tideGradient'], 'relative md:px-5')}
      data-cy="membership-benefits"
    >
      <LayoutGrid>
        <GridItem
          colStart={{ sm: 'main', lg: 'full' }}
          colEnd={{ sm: 'main', lg: 14 }}
          className="relative lg:flex lg:justify-around lg:py-14"
        >
          <div className="relative aspect-square max-w-[553px]">
            <Image
              src="membership/ceramic_tide_tilt"
              format="png"
              localizedAlt="jade_tide_product_img_alt"
              loading="lazy"
              className="object-contain"
              fill
              sizes="(max-width: 553px) 100vw, 50vw"
              data-cy="benefit-ring-lines-extend"
            />
          </div>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', lg: 15 }}
          colEnd={{ sm: 'main', lg: 23 }}
          className="relative flex justify-around pt-8 pb-20 lg:py-14"
        >
          <div
            className="flex grow justify-center text-gray-500 sm:flex-col"
            data-cy="membership-benefits-text-section"
          >
            <div>
              <Typography
                Element="h3"
                variant="body-large"
                weight={'bold'}
                className="pb-4 text-xl text-gray-500"
              >
                {t('membership_benefits_first_month_title')}
              </Typography>
              <Typography className="pb-8 text-gray-500 md:text-xl lg:pb-14">
                <RichText
                  messageKey="membership_benefits_first_six_months_body_site_redesign_new"
                  tValues={membershipPricingValues}
                />
              </Typography>
            </div>

            <Typography
              Element="h3"
              variant="body-large"
              weight={'bold'}
              className="pb-4 text-xl text-gray-500"
            >
              {t('membership_benefits_evolving_title')}
            </Typography>
            <Typography className="pb-8 text-gray-500 md:text-xl lg:pb-14">
              {t('membership_benefits_evolving_body')}
            </Typography>

            <Typography
              Element="h3"
              variant="body-large"
              weight={'bold'}
              className="pb-4 text-xl text-gray-500"
            >
              {t('membership_benefits_nonpaying_members_title')}
            </Typography>
            <Typography className="text-gray-500 md:text-xl lg:pb-14">
              {t('membership_benefits_nonpaying_members_body')}
            </Typography>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};
export default MembershipBenefits;
